export enum OracleStatusEnum {
  open = 'OP',
  close = 'CL'
};

export enum OracleStatusDisplayEnum {
  open = 'OPEN',
  close = 'CLOSED'
};
